import { ComponentPayload } from 'base/webflow/schema';
import { computedFn } from 'mobx-utils';
import React from 'react';
import { NodeDecorator } from './decorators';

export const playInteractionsDecorator: NodeDecorator = function* (node, ctx) {
  const stylesByNode = getPlayedStyles(ctx.ix2);
  const style = stylesByNode.get(node._id);
  if (style) yield { style };
};

function shouldRenderAsPlayed(title: string) {
  // This modal just shows photo previews, don't block the content by opening it
  if (title === 'Product header 2 modal [Open]') return false;
  // Avoid blocking content on links components with the "join our newsletter" modals.
  if (title.match(/^Links \d+ Modal \[Open\]$/)) return false;
  // These don't have the word "modal" in them but should still be rendered as open.
  if (title.match(/^Multi Form \d+ \[Open\]$/)) return true;
  // Open all modals
  return title.match(/modal.*\[open\]/i) !== null;
}

/* exported for testing only */
export const getPlayedStyles = computedFn((ix2: ComponentPayload['ix2']) => {
  const result = new Map<string, React.CSSProperties>();
  for (const actionList of ix2.actionLists) {
    if (!shouldRenderAsPlayed(actionList.title)) {
      continue;
    }
    const items =
      actionList.actionItemGroups?.flatMap((g) => g.actionItems) || [];
    for (const item of items) {
      const node = getNodeId(item.config.target?.nodeId || '');
      if (!node) continue;
      const styles = result.get(node) || {};
      const { value, unit } = item.config;
      switch (item.actionTypeId) {
        case 'STYLE_OPACITY':
          if (unit !== '%' || typeof value !== 'number') {
            console.error('can not parse STYLE_OPACITY', { value, unit });
            break;
          }
          styles.opacity = value / 100;
          break;
        case 'GENERAL_DISPLAY':
          styles.display = value as React.CSSProperties['display'];
          break;
        default:
          console.warn(
            `IX2 ${actionList.title} has unknown action type ${item.actionTypeId}`,
          );
      }
      result.set(node, styles);
    }
  }
  return result;
});

/** In ix2, ids are either just a node id or a "<pageId>|<nodeId>" string */
function getNodeId(id: string) {
  const parts = id.split('|');
  return parts.length === 2 ? parts[1] : id;
}
